import React from "react";
import ExperienceInformationView from "./view";

const ExperienceInformation = () => {
  return <ExperienceInformationView />;
};

export default ExperienceInformation;